import Head from 'next/head'
import shopInfos from 'template/infos'
const { name, url } = shopInfos

const Seo: React.FC = () => <Head>

  <title>{`Kundenkonto bei ${name}`}</title>

  <meta name='description' content={
    `Mit deinem persönlichen Konto hast du alle Bestellungen auf einen Blick 
    und kannst deine persönlichen Daten ganz schnell und bequem verwalten.`
  } />

  <link rel='canonical' href={`${url}kundenkonto`} />

</Head>

export default Seo
